<style scoped>

</style>

<template>
  <mu-list-item>
    <mu-list-item-action>
      <mu-circular-progress></mu-circular-progress>
    </mu-list-item-action>
    <mu-list-item-content>
      <mu-list-item-title>
        {{$t('notification.export.' + exportItem.type, {object: exportItem.text})}}
      </mu-list-item-title>
    </mu-list-item-content>
  </mu-list-item>
</template>

<script>

// Components

// Library
import axios from "axios";

export default {
  name: 'ExportQueueItem',
  components: {

  },
  props: {
    exportItem: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
    
    }
  },
  computed: {
    triggerRefresh() {
      return this.$store.getters.triggerRefresh;
    },
  },
  mounted() {
    this.fetchJobProgress(this.exportItem.uid);
  },
  watch: {
    
  },
  methods: {
    fetchJobProgress(uid) {
      this.interval = setInterval(() => {
        axios({
          method: 'get',
          url: this.$store.getters.urlApi + "job/progress/" + uid,
          headers: {
            token: this.$store.state.auth.token
          },
          }).then(response => {
            if(response.data.data.result)
              this.onJobDone(uid);
          })
          .catch(err => {
            console.log(err.message)
          });
      }, 3000);
    },
    onJobDone(uid) {
      axios({
        method: 'get',
        url: this.$store.getters.urlApi + 'file?path=csv/' + uid + '.csv',
          headers: {
            token: this.$store.state.auth.token
          },
          responseType: 'arraybuffer'
      }).then(res => {
        let blob = new Blob([res.data], { type: 'text/csv' });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.exportItem.text + '_' + this.exportItem.type + '_' + new Date().getTime() + '.csv';
        link.click();
        clearInterval(this.interval);
        this.$store.commit('triggerRefresh');
        this.$store.commit('exportQueuePop', this.exportItem.exportId);
      })
      .catch(err => {
        console.log(err.message)
      });
    },
  },

}
</script>
